import { render, staticRenderFns } from "./visits-visitors-chart.vue?vue&type=template&id=00c0dd2c&scoped=true&lang=pug&"
import script from "./visits-visitors-chart.vue?vue&type=script&lang=ts&"
export * from "./visits-visitors-chart.vue?vue&type=script&lang=ts&"
import style0 from "./visits-visitors-chart.vue?vue&type=style&index=0&id=00c0dd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0dd2c",
  null
  
)

export default component.exports